import * as Sentry from '@sentry/react';
import { createRoot, type Root } from 'react-dom/client';

/**
 * One React 18 root per DOM mount host. Page Builder `livePreviewUpdated` re-runs init;
 * reuse the root and call `render` again instead of `createRoot` on the same node.
 */
const rootByHost = new WeakMap<Element, Root>();

const sentryRootOptions = {
  onUncaughtError: Sentry.reactErrorHandler(),
  onCaughtError: Sentry.reactErrorHandler(),
  onRecoverableError: Sentry.reactErrorHandler(),
};

export function getOrCreateRoot(host: Element): Root {
  let root = rootByHost.get(host);
  if (root === undefined) {
    // Matrix Page Builder may leave placeholder markup inside mount hosts.
    host.replaceChildren();
    root = createRoot(host, sentryRootOptions);
    rootByHost.set(host, root);
  }
  return root;
}
